module.exports = __webpack_public_path__ + "img/btn_sm_sign-in.a83cf5d.png";